module.exports = __webpack_public_path__ + "img/depmap_svg_V122.9af27af1.svg";